/**
 * Modale d'annonce (une seule fois) : les résultats des années antérieures sont
 * désormais consultables dans « Mon parcours ». Design sobre et professionnel.
 * 2026-10-14.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { GraduationCap, ArrowRight, X, Check } from 'lucide-react';

export function AnnonceParcoursModal({ onClose }: { onClose: () => void }) {
  const navigate = useNavigate();

  const voir = () => {
    onClose();
    navigate('/portail/historique');
  };

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
      onClick={onClose}
    >
      <div
        className="w-full max-w-sm bg-gray-900 border border-gray-700 rounded-2xl shadow-2xl overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* En-tête sobre */}
        <div className="relative px-5 pt-5 pb-4 border-b border-gray-800">
          <button
            onClick={onClose}
            aria-label="Fermer"
            className="absolute top-3 right-3 text-gray-500 hover:text-gray-300 transition-colors"
          >
            <X size={18} />
          </button>
          <div className="w-11 h-11 rounded-xl bg-indigo-500/15 border border-indigo-500/30 flex items-center justify-center mb-3">
            <GraduationCap size={22} className="text-indigo-400" />
          </div>
          <h2 className="text-base font-semibold text-gray-100 leading-snug">
            Votre parcours complet est disponible
          </h2>
          <p className="text-[13px] text-gray-400 mt-1.5 leading-relaxed">
            Vous pouvez désormais consulter vos résultats de <span className="text-gray-200 font-medium">tous les semestres</span> de
            vos années précédentes, année par année.
          </p>
        </div>

        {/* Points clés */}
        <div className="px-5 py-4 space-y-2.5">
          {[
            'Toutes vos années, du S1 au dernier semestre',
            'Moyennes, décisions et évolution de votre parcours',
            'Vos points forts par matière',
          ].map((t) => (
            <div key={t} className="flex items-start gap-2.5">
              <Check size={15} className="text-emerald-400 shrink-0 mt-0.5" />
              <span className="text-[13px] text-gray-300 leading-snug">{t}</span>
            </div>
          ))}
        </div>

        {/* Actions */}
        <div className="px-5 pb-5 pt-1 space-y-2">
          <button
            onClick={voir}
            className="w-full inline-flex items-center justify-center gap-2 py-2.5 rounded-lg bg-indigo-600 hover:bg-indigo-500 text-white text-sm font-medium transition-colors"
          >
            Voir mon parcours <ArrowRight size={16} />
          </button>
          <button
            onClick={onClose}
            className="w-full py-2.5 rounded-lg text-gray-400 hover:text-gray-200 text-sm font-medium transition-colors"
          >
            Plus tard
          </button>
        </div>
      </div>
    </div>
  );
}
